import { Card, Flex } from "antd";
import { FC } from "react";
import { TaskShelfSize } from "tm-shared/types";

import { PrimaryText, SecondaryText } from "@/components/Typography/Styled";

import { InfoRowList } from "../components/InfoRowList";
import { TaskViewModal } from "../TaskViewModal";

interface ShelfSizeViewModalProps {
    task: TaskShelfSize;
    onClose: () => void;
}

export const ShelfSizeViewModal: FC<ShelfSizeViewModalProps> = ({
    task,
    onClose,
}) => {
    const taskPayload = task.payload;
    const completedAt = task?.completedAt;

    if (!taskPayload || !completedAt) return null;

    const { shelving, total } = taskPayload;

    const infoRows = [{ label: "Загальна довжина:", value: `${total} см.` }];

    return (
        <TaskViewModal title={task.name} onClose={onClose} taskInfo={task.info}>
            {total > 0 && (
                <Flex vertical gap={16}>
                    <InfoRowList items={infoRows} />

                    {shelving.map(({ name, shelfs }, index) => {
                        return (
                            <Card
                                key={name + index}
                                styles={{ body: { padding: 16 } }}
                            >
                                <Flex vertical gap={8}>
                                    <PrimaryText>{name}</PrimaryText>

                                    {shelfs.map(({ name, size }) => (
                                        <Flex key={name + size} gap={8}>
                                            <SecondaryText>
                                                {name}:
                                            </SecondaryText>

                                            <PrimaryText>
                                                {size} см.
                                            </PrimaryText>
                                        </Flex>
                                    ))}
                                </Flex>
                            </Card>
                        );
                    })}
                </Flex>
            )}

            {total === 0 && <PrimaryText>Полиці відсутні</PrimaryText>}
        </TaskViewModal>
    );
};
